import { call, put, select, take, delay } from "redux-saga/effects";
import getTransactionPromise from '@/services/tradeIn/transaction';
import { actions } from '@/reducers/devices'
import { STEPS } from '@/component/stepper/constants'

const contextStore = (state) => state.main.context;

const getCurrentStep = (searchedState) => {
  let finalStep = null;
  Object.keys(STEPS).forEach(item => {
      if (STEPS[item].STATES.includes(searchedState)) {
        finalStep = STEPS[item];
      }
  });
  return finalStep;
}

export function* getTransaction(data) {
  const contextApi = yield select(contextStore);
  try {
    const { payload } = data;
    const response = yield call(getTransactionPromise, {
      context: contextApi,
      transactionId: payload.data,
    });

    if(response){
      const { uuid, event, final_grade, init_grade_max, init_transaction_obj, final_transaction_obj } = response;
      const currentEvent = Array.isArray(event) && event[event.length-1]
      const { estado, fecha} = currentEvent;
      
      let Modelo, Precio_Final, Precio_Inicial;

      if (final_transaction_obj) {
        ({ Modelo, Precio_Final, Precio_Inicial } = final_transaction_obj);
      } else {
        ({ Modelo, Precio_Final, Precio_Inicial } = init_transaction_obj);
      }
      const currentStep = getCurrentStep(estado);
      if(currentStep){
        const transactionToReturn = {
          currentStep,
          // currentEvent,
          date: fecha,
          model: Modelo,
          price: Precio_Final || Precio_Inicial,
          co: uuid,
          finalGrade: final_grade || init_grade_max,
        };
        yield put(
          actions.setTransaction(transactionToReturn)
        );
      }
    }
    
  } catch (error) {
    yield put(
      actions.setTransaction({})
    );
  }
}
